import { compose, lifecycle, withHandlers, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { activeShopSplitPaymentsEnabled } from '../../../auth/selectors';
import ChargeAmount from '../components/ChargeAmount';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import { setChargeAmount } from '../reducer/chargeAmount/actions';
import { getOutstanding } from '../../validated/selectors';
import { getIsFetching } from '../reducer/isFetching/selectors';

const limitValue = withPropsOnChange(
  ['value'],
  (props) => {
    if (props.value > props.amountOwed) props.setChargeAmount(props.amountOwed);
    if (props.value < 0) props.setChargeAmount(props.value * -1);
  }
);

const ChargeAmountContainer = compose(
  connect(
    state => ({
      value: getChargeAmount(state),
      amountOwed: getOutstanding(state),
      disabled: (
        !activeShopSplitPaymentsEnabled(state) ||
        getIsFetching(state) ||
        !getOutstanding(state)
      ),
      splitPaymentDisabled: !activeShopSplitPaymentsEnabled(state),
    }),
    { setChargeAmount },
  ),
  lifecycle({
    componentDidMount() {
      this.props.setChargeAmount(this.props.amountOwed);
    },
  }),
  withPropsOnChange(
    ['amountOwed'],
    (props) => {
      props.setChargeAmount(props.amountOwed);
    }
  ),
  withHandlers({
    onChange: props => amount => props.setChargeAmount(amount),
  }),
  limitValue,
)(ChargeAmount);

export default ChargeAmountContainer;
